import CategoryAdd from '../components/Categories/CategoryAdd';
import { t } from '../i18n';

// Standalone route for the same form the list page shows in its Drawer.
// The form itself renders no chrome, so the page supplies it.
export default function CategoryAddPage() {
  return (
    <div className="max-w-2xl mx-auto px-6 py-8">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">{t('Нова категорија')}</h2>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <CategoryAdd />
      </div>
    </div>
  );
}
